import { Button } from '@/components/ui/button';
import { FlexCol } from '@/components/ui/flex';
import { useWorkspacesService } from '@/services/workspaces';
import {
  getLastVisitedWorkspaceUname,
  getRestoredAppPath,
} from '@/utils/lastWorkspaceSession';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function WorkspacesPage() {
  const { workspaces, error, isLoading } = useWorkspacesService();
  const navigate = useNavigate();

  useEffect(() => {
    if (!workspaces?.length) {
      return;
    }
    const restored = getRestoredAppPath(workspaces);
    if (restored) {
      navigate(restored, { replace: true });
      return;
    }
    const uname =
      getLastVisitedWorkspaceUname(workspaces) ?? workspaces[0].uname;
    navigate(`/workspace/${uname}`, { replace: true });
  }, [workspaces, navigate]);

  if (isLoading) {
    return null;
  }

  if (error) {
    return (
      <FlexCol className="h-screen bg-background items-center justify-center">
        <FlexCol
          gap="4"
          className="items-center justify-center max-w-md text-center"
        >
          <h1 className="text-2xl font-semibold text-red-600">
            Error Loading Workspaces
          </h1>
          <p className="text-secondary">
            There was a problem loading your workspaces. Please try again.
          </p>
          <Button onClick={() => window.location.reload()}>Try Again</Button>
        </FlexCol>
      </FlexCol>
    );
  }
}
